const scrollInEls = document.querySelectorAll(".scroll-in");

const observer = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("displayed");
        observer.unobserve(entry.target);
      }
    });
  },
  {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  }
);

scrollInEls.forEach(object => observer.observe(object));